export default "__VITE_ASSET__023b4c1e__"